module.exports = __webpack_public_path__ + "static/media/Evil Mech.2c1dd742.jpg";